import { render, staticRenderFns } from "./reviewreport.vue?vue&type=template&id=3f05214e&scoped=true&"
import script from "./reviewreport.vue?vue&type=script&lang=js&"
export * from "./reviewreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f05214e",
  null
  
)

export default component.exports